import { j as t } from "../../../../jsx-runtime.BREq8dyb.js";
import { useSize as I, useBoolean as M } from "@decentriq/hooks";
import { styled as q, Button as D, Box as i, Tooltip as G } from "@mui/joy";
import { memo as J, forwardRef as K, useRef as P, useState as y, useCallback as Q, useEffect as U, useImperativeHandle as V, Fragment as X } from "react";
const W = q(D)(({
  theme: d
}) => ({
  backgroundColor: "var(--joy-palette-neutral-100)",
  borderRadius: d.radius.xs,
  cursor: "row-resize",
  height: "100%",
  margin: "0 4px",
  minHeight: "auto",
  minWidth: "auto",
  padding: 0,
  width: "100%"
}));
W.displayName = "FullHeightToggleButton";
const Y = J(K(({
  children: d,
  dataTestid: x,
  startAdornment: m,
  endAdornment: u,
  onClick: v,
  actions: p,
  fullHeightToggleButtonTooltipTitlePlacement: C = "bottom-end",
  fullHeightToggleButtonTooltipTitle: b = "Toggle full height",
  ContentWrapperProps: j,
  StartAdornmentWrapperProps: F,
  ContentProps: T,
  EndAdornmentWrapperProps: B,
  ActionsWrapperProps: k,
  FullHeightToggleButtonWrapperProps: S
}, E) => {
  const r = P(null), {
    width: O
  } = I(r) || {}, [f, {
    toggle: R
  }] = M(!1), [w, H] = y(!1), [z, N] = y(!1), g = Q((l) => {
    const {
      parentNode: n,
      style: o,
      offsetHeight: s,
      offsetWidth: a
    } = l;
    let e = document.createElement("div");
    e.style.position = "absolute", e.style.visibility = "hidden", e.style.fontFamily = o.fontFamily || "inherit", e.style.fontSize = o.fontSize || "inherit", e.innerHTML = "A", n.appendChild(e), e.parentNode.removeChild(e), e = l.cloneNode(!0), e.style.position = "absolute", e.style.visibility = "hidden", e.style.overflow = "visible", e.style.whiteSpace = "nowrap", e.style.maxHeight = "1.5rem", e.style.paddingRight = "0", n.appendChild(e);
    const {
      scrollWidth: h,
      scrollHeight: c
    } = e;
    e.style.whiteSpace = "normal";
    const {
      scrollWidth: L,
      scrollHeight: A
    } = e;
    return e.parentNode.removeChild(e), {
      contentHeightNormal: A,
      contentHeightNowrap: c,
      contentWidthNormal: L,
      contentWidthNowrap: h,
      elementHeight: s,
      elementWidth: a
    };
  }, []);
  return U(() => {
    const l = r?.current;
    if (l) {
      const {
        elementWidth: n,
        elementHeight: o,
        contentWidthNowrap: s,
        contentHeightNowrap: a,
        contentHeightNormal: e
      } = g(l), h = n < s || o < a, c = o < e;
      H(h), N(c);
    }
  }, [g, d, r, O]), V(E, () => ({
    checkOverflowingChildren() {
      const l = r?.current;
      if (l) {
        const {
          elementWidth: n,
          elementHeight: o,
          contentWidthNowrap: s,
          contentHeightNowrap: a,
          contentHeightNormal: e
        } = g(l), h = n < s || o < a, c = o < e;
        H(h), N(c);
      }
    }
  })), /* @__PURE__ */ t.jsxs(X, { children: [
    /* @__PURE__ */ t.jsxs(i, { className: "contentWrapper", ...j, children: [
      m ? /* @__PURE__ */ t.jsx(i, { className: "startAdornmentWrapper", ...F, children: m }) : null,
      /* @__PURE__ */ t.jsx(i, { className: "content", "data-testid": x, onClick: v, ref: r, style: {
        "--mask-image": w ? "linear-gradient(to right, black 90%, transparent 100%)" : "none",
        "--max-height": f ? "none" : "1.5rem",
        "--padding-right": w ? "2.5%" : 0,
        "--white-space": f ? "normal" : "nowrap"
      }, ...T, children: d }),
      u ? /* @__PURE__ */ t.jsx(i, { className: "endAdornmentWrapper", ...B, children: u }) : null
    ] }),
    p ? /* @__PURE__ */ t.jsx(i, { className: "actionsWrapper", ...k, children: p }) : null,
    z ? /* @__PURE__ */ t.jsx(i, { className: "fullHeightToggleButtonWrapper", ...S, children: /* @__PURE__ */ t.jsx(G, { disableFocusListener: !0, disableTouchListener: !0, placement: C, title: b, children: /* @__PURE__ */ t.jsx(W, { onClick: R }) }) }) : null
  ] });
}));
Y.displayName = "Content";
export {
  Y as default
};
//# sourceMappingURL=Content.js.map
